interface SelectionTooLargeStateProps {
  wordCount: number;
}

const SelectionTooLargeState = ({ wordCount }: SelectionTooLargeStateProps) => {
  return (
    <div
      className="flex flex-col items-center justify-center py-8 px-5 text-center h-full animate-fade-in"
      role="status"
    >
      {/* Icon */}
      <div className="w-12 h-12 bg-amber-100 rounded-2xl flex items-center justify-center mb-4">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round">
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
          <line x1="12" y1="9" x2="12" y2="13"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      </div>

      <h3 className="text-base font-bold text-gray-900 mb-1.5 tracking-tight">
        Selection too large
      </h3>
      <p className="text-xs text-gray-500 mb-5 max-w-[220px] leading-relaxed">
        You've selected <strong className="text-gray-700">{wordCount} words</strong>. The AI works best on passages up to 1,200 words.
      </p>

      <div className="w-full bg-amber-50 border border-amber-100 rounded-xl p-3.5 text-left">
        <p className="text-[10px] font-bold text-amber-700 uppercase tracking-wider mb-1.5">
          Recommendation
        </p>
        <p className="text-xs text-amber-800 leading-relaxed">
          Select a smaller section — a few paragraphs or a single topic — for higher-quality, faster results.
        </p>
      </div>
    </div>
  );
};

export default SelectionTooLargeState;
